import {
  Row,
  Col,
  Select_,
  Form,
  Button,
  SuccessNotification,
} from "components/common";
import React, { useState, useEffect } from "react";
import { callGetApi, callPostApi } from "utils/api";
import { Wrapper } from "./UitilityModal.styled";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

const UitilityModal = ({
  details,
  setLat,
  setLng,
  lat,
  lng,
  leadId,
  setUitilityModal,
  locationId_,
}) => {
  const [form] = Form.useForm();
  const [uitilityOptions, setUitilityOptions] = useState([]);
  const [uitilityName, setUitilityName] = useState([]);

  const postProposal = (data) => {
    callPostApi(
      "/leads/request/a/new/lead/proposal",
      data,
      onSuccessPostProposal,
      onFailPostProposal
    );
  };
  const onSuccessPostProposal = (data) => {
    SuccessNotification("send Proposal");
    form.setFieldsValue({
      id: "",
    });
    setUitilityModal(false);
  };
  const onFailPostProposal = (err) => {
    console.log(err);
  };

  const onSuccessUitility = (data) => {
    setUitilityOptions(data);
  };
  const onFailUitility = (err) => {
    console.log(err);
  };

  const getUitilityApi = () => {
    callGetApi(
      `/leads/get/utility/phx/gosolo/companies/${locationId_}`,
      onSuccessUitility,
      onFailUitility
    );
  };

  const hanlde = (e) => {
    uitilityOptions.filter((el) => {
      if (e === el?.id) {
        setUitilityName(el);
      }
    });
  };

  useEffect(() => {
    if (locationId_) {
      getUitilityApi();
    }
  }, [locationId_]);

  const onFinish = (values) => {
    const obj = {
      lead: {
        ...details,
        lat: lat,
        lng: lng,
        utility_id: values?.id,
        utility_name: uitilityName?.name,
        id: leadId,
        rep: details?.rep?.email,
        company_id: 9146,
      },
    };
    postProposal(obj);
  };

  const MapWithAMarker = withScriptjs(
    withGoogleMap((props) => (
      <GoogleMap
        defaultZoom={20}
        defaultCenter={{ lat: lat, lng: lng }}
        onClick={(e) => {
          setLat(e?.latLng?.lat());
          setLng(e?.latLng?.lng());
        }}
        streetView={true}
        mapTypeId="satellite"
      >
        <Marker position={{ lat: lat, lng: lng }} />
      </GoogleMap>
    ))
  );
  return (
    <Wrapper>
      <Form name="basic" autoComplete="off" onFinish={onFinish} form={form}>
        <Row gutter={[10, 10]}>
          <Col span={6} className="uitility-col">
            <p>Select Utility:</p>
          </Col>
          <Col span={18} className="uitility-select-col">
            <Form.Item name="id">
              <Select_
                placeholder="Select Uitility"
                name
                options={uitilityOptions}
                onChange={hanlde}
              />
            </Form.Item>
          </Col>
          <Col span={24} style={{ height: "400px" }}>
            <MapWithAMarker
              googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDed7z5G3jV7NTuZZaCkoh6XckoQepg--k&v=3.exp&libraries=geometry,drawing,places"
              loadingElement={<div style={{ height: `100%` }} />}
              containerElement={<div style={{ height: `400px` }} />}
              mapElement={<div style={{ height: `100%` }} />}
            />
          </Col>
          <Col span={24}>
            <Button title="Submit" htmlType="submit" />
          </Col>
        </Row>
      </Form>
    </Wrapper>
  );
};

export default UitilityModal;
